import React, {PureComponent} from "react";
import moment from "moment";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import {DialogTitle} from "@mui/material";
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import {SentimentVeryDissatisfied, SentimentVerySatisfied} from "@mui/icons-material";
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import {withRouter} from "../../../hooks/withRouter";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {LocalizationProvider, TimePicker} from "@mui/lab";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class WorkoutCompleteEditForm extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			workout: props.workout,
			isOpen: false,
			isSubmissionLoading: false,
			workoutDuration: null,
			submitError: null,
			moodLevel: props.workout.moodLevel,
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.isOpen) {
			this.setState({
				workout: nextProps.workout,
				isOpen: true,
				moodLevel: nextProps.workout.moodLevel,
				workoutDuration: this.getDefaultWorkoutDurationDateTime(), // If the dialog is opened again, reset this date.
				isSubmissionLoading: false,
			});
		} else {
			this.setState({
				isOpen: false,
			});
		}
	}
	
	updateWorkoutDuration = (val) => {
		this.setState({
			workoutDuration: val,
		});
	}

	submitWorkout = async (event, moodLevel = null, workoutEndedMoment = null) => {
		event.preventDefault();

		if (this.isWorkoutAlreadyFinished()) {
			await this.submitAsEdit(moodLevel, workoutEndedMoment);
			return;
		}
		
		await this.submitAsNew(moodLevel, workoutEndedMoment);
	}
	
	submitAsEdit = async (moodLevel = null, workoutEndedMoment = null) => {
		this.setState({
			isSubmissionLoading: true,
		});

		let workout = {
			id: this.state.workout.id,
			dateTimeEnded: workoutEndedMoment ? workoutEndedMoment.format('L, h:mm:ss A') : moment().format('L, h:mm:ss A'),
		};

		if (moodLevel) {
			workout['moodLevel'] = moodLevel;
		}

		try {
			const response = await fetch(UrlBuilder.workout.workoutsApi(), {
				method: 'PUT',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(workout)
			});

			if (!response.ok) {
				throw new Error(`Server error (${response.status})`);
			}

			this.props.closeSelfFunc(true);
			this.setState({ isSubmissionLoading: false });
		} catch (e) {
			this.setState({ isSubmissionLoading: false, submitError: 'Failed to save workout. Please try again.' });
		}
	}

	submitAsNew = async (moodLevel = null, workoutEndedMoment = null) => {
		this.setState({
			isSubmissionLoading: true,
		});

		let workout = {
			dateTimeEnded: workoutEndedMoment ? workoutEndedMoment.format('L, h:mm:ss A') : moment().format('L, h:mm:ss A'),
		};

		if (moodLevel) {
			workout['moodLevel'] = moodLevel;
		}

		try {
			const response = await fetch(UrlBuilder.workout.finishWorkoutApi(), {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(workout)
			});

			if (!response.ok) {
				throw new Error(`Server error (${response.status})`);
			}

			const data = await response.json();

			this.props.closeSelfFunc(true);
			this.props.setUser(data.data);

			if (this.state.workout.routines.length > 0) {
				this.props.navigate(UrlBuilder.workout.workoutDetailPage(this.state.workout.id, true));
			}
		} catch (e) {
			this.setState({ isSubmissionLoading: false, submitError: 'Failed to submit workout. Please try again.' });
		}
	}

	getMomentEnded = (workoutDurationDateTime) => {
		const dateTimeStarted = moment(this.state.workout.dateTimeStarted);

		return dateTimeStarted
			.add(workoutDurationDateTime.getHours(), 'hours')
			.add(workoutDurationDateTime.getMinutes(), 'minutes');
	}

	getDefaultWorkoutDurationDateTime = () => {
		if (this.state.workout.isPastWorkout && !this.isWorkoutAlreadyFinished()) {
			return null;
		}
		
		const dateTimeStarted = moment(this.state.workout.dateTimeStarted);
		
		const dateTimeEnded = this.isWorkoutAlreadyFinished() ? moment(this.state.workout.dateTimeEnded) : moment();
		
		let workoutDurationObj = moment.duration(dateTimeEnded.diff(dateTimeStarted));
		let workoutDuration = moment.utc(workoutDurationObj.asMilliseconds());
		
		// The duration is any date but with a specific time.
		const duration = new Date();
		duration.setHours(workoutDuration.hours());
		duration.setMinutes(workoutDuration.minutes());
		duration.setMilliseconds(workoutDuration.milliseconds());
		
		return duration;
	}

	isWorkoutAlreadyFinished = () => {
		return !!this.state.workout.dateTimeEnded;
	}

	openConfirmationDialog = (isOpen) => {
		if (isOpen) {
			this.setState({
				isConfirmationDialogOpen: true,
				
			});
		} else {
			this.setState({
				isConfirmationDialogOpen: false,
			});
		}
	}
	
	setMoodLevel = (moodLevel) => {
		this.setState({
			moodLevel: this.state.moodLevel === moodLevel ? null : moodLevel, // If equal to now, remove it.
		});
	}

	clearSubmitError = () => {
		this.setState({ submitError: null });
	}

	getDialogTitle = () => {
		if (this.isWorkoutAlreadyFinished()) return 'Edit Workout';
		return this.state.workout.isPastWorkout ? 'Complete Past Workout' : 'Complete Workout';
	}

	getSubmitLabel = () => {
		if (this.isWorkoutAlreadyFinished()) return 'Save Workout';
		return this.state.workout?.routines?.length > 0 ? 'Submit Workout' : 'Quit Workout';
	}

	renderTimeBlock = (label, time, date) => (
		<Box sx={{ textAlign: 'center' }}>
			<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, letterSpacing: 0.5, textTransform: 'uppercase', fontSize: 11 }}>
				{label}
			</Typography>
			<Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2, mt: 0.25 }}>
				{time}
			</Typography>
			{date && (
				<Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 11 }}>
					{date}
				</Typography>
			)}
		</Box>
	)

	renderMoodButton = (level, icon) => (
		<IconButton
			onClick={() => this.setMoodLevel(level)}
			sx={{
				p: 1,
				border: 2,
				borderColor: this.state.moodLevel === level ? 'secondary.main' : 'divider',
				bgcolor: this.state.moodLevel === level
					? (theme) => theme.palette.mode === 'dark' ? 'rgba(245,0,87,0.12)' : 'rgba(245,0,87,0.06)'
					: 'transparent',
				transition: 'all 0.15s ease',
				'&:hover': {
					borderColor: 'secondary.main',
				},
			}}
		>
			{React.cloneElement(icon, {
				sx: {
					fontSize: 28,
					color: this.state.moodLevel === level ? 'secondary.main' : 'text.secondary',
				}
			})}
		</IconButton>
	)

	render() {
		const dateTimeStarted = moment(this.state.workout.dateTimeStarted);
		const momentEnded = this.state.workoutDuration ? this.getMomentEnded(this.state.workoutDuration) : null;

		return (
			<>
			<Dialog
				fullWidth
				open={this.state.isOpen}
				onClose={() => this.props.closeSelfFunc(false)}
				TransitionComponent={Transition}
				PaperProps={{ sx: { borderRadius: 3 } }}
			>
				<DialogTitle sx={{ pb: 1 }}>
					<Typography variant="h6" sx={{ fontWeight: 600 }}>
						{this.getDialogTitle()}
					</Typography>
				</DialogTitle>

				<DialogContent sx={{ pt: 2 }}>
					{/* Time flow: Started → Duration → Ended */}
					<Box sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 1,
						py: 2,
						px: 1.5,
						bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
						borderRadius: 2,
						mb: 3,
					}}>
						{this.renderTimeBlock(
							'Started',
							dateTimeStarted.format('LT'),
							dateTimeStarted.format('DD/MM/YYYY'),
						)}

						<ArrowForwardIcon sx={{ color: 'text.disabled', fontSize: 18, mt: 1, flexShrink: 0 }} />

						<Box sx={{ textAlign: 'center', flexShrink: 0 }}>
							<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, letterSpacing: 0.5, textTransform: 'uppercase', fontSize: 11, display: 'block' }}>
								Duration
							</Typography>
							<Box sx={{ mt: 0.5 }}>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<TimePicker
										ampm={false}
										toolbarTitle='Pick workout length (hh:mm)'
										openTo="hours"
										views={["hours", "minutes"]}
										label='hh:mm'
										inputFormat="HH:mm"
										value={this.state.workoutDuration}
										onChange={this.updateWorkoutDuration}
										renderInput={(params) => <TextField {...params} size="small" sx={{ width: 88 }} />}
									/>
								</LocalizationProvider>
							</Box>
						</Box>

						<ArrowForwardIcon sx={{ color: 'text.disabled', fontSize: 18, mt: 1, flexShrink: 0 }} />

						{this.renderTimeBlock(
							'Ended',
							momentEnded ? momentEnded.format('LT') : '—',
							momentEnded ? momentEnded.format('DD/MM/YYYY') : null,
						)}
					</Box>

					{/* Mood */}
					<Box sx={{ textAlign: 'center' }}>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, letterSpacing: 0.5, textTransform: 'uppercase', fontSize: 11, display: 'block', mb: 1.5 }}>
							How did it feel?
						</Typography>
						<Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
							{this.renderMoodButton(1, <SentimentVeryDissatisfied />)}
							{this.renderMoodButton(2, <SentimentSatisfiedIcon />)}
							{this.renderMoodButton(3, <SentimentVerySatisfied />)}
						</Box>
					</Box>
				</DialogContent>

				<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
					<Button
						variant="outlined"
						onClick={() => this.props.closeSelfFunc(false)}
						sx={{ textTransform: 'none', fontWeight: 500 }}
					>
						Cancel
					</Button>

					<Box sx={{ flex: 1 }} />

					<Button
						variant="contained"
						color="secondary"
						disabled={this.state.isSubmissionLoading || !this.state.workoutDuration}
						onClick={(e) => this.submitWorkout(e, this.state.moodLevel, this.getMomentEnded(this.state.workoutDuration))}
						sx={{ textTransform: 'none', fontWeight: 600, px: 3 }}
					>
						{this.state.isSubmissionLoading ? (
							<><CircularProgress size={16} color="inherit" sx={{ mr: 1 }} /> Saving...</>
						) : (
							this.getSubmitLabel()
						)}
					</Button>
				</DialogActions>
			</Dialog>

			<Snackbar open={!!this.state.submitError} autoHideDuration={6000} onClose={this.clearSubmitError}>
				<Alert onClose={this.clearSubmitError} severity="error" sx={{ width: '100%' }}>
					{this.state.submitError}
				</Alert>
			</Snackbar>
			</>
		);
	}
}

export default withRouter(WorkoutCompleteEditForm);